import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaChevronRight } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

import TappableCard from '../common/TappableCard';
import { PrimaryButton } from '../common/Buttons';

import DoctorPlaceHolder from '../../images/consultations/doctor-placeholder.svg';
import DoctorOrgIcon from '../../images/consultations/new-flow/hospital.svg';
import Top from '../../images/top.svg';
import Bottom from '../../images/Bottom.svg';
import vaccinationDisclaimerImage from '../../images/vaccination/List/Card/Price Icon  1.svg';
import HospitalIcon from '../../images/vaccination/HospitalFull.svg';
import SameDayTimeSlotLogo from '../../images/sameDayTimeSlotLogo.svg';
import HSign from '../../images/vaccination/H-sign.svg';
import GreenPhone from '../../images/consultations/Green-phone.svg';
import WebsiteImage from '../../images/consultations/Blue-website.svg';
import Medal from '../../images/consultations/Medal.svg';
import HospitalBuildingGreen from '../../images/consultations/green-hospital.svg';
import PaymentIn30MinsIcon from '../../images/consultations/PaymentIn30Mins.svg';
import PaymentIn60MinsIcon from '../../images/consultations/PaymentIn60Mins.svg';
import PrimaryButtonRect1 from '../../images/pre-book/PrimaryButtonRect1.svg';
import PrimaryButtonRect2 from '../../images/pre-book/PrimaryButtonRect2.svg';
import PreBookStepsModal from './PreBookStepsModal';
import Modal from '../../containers/common/Modal';
import { FlyInTransition } from '../transitions/transitions';
import { logEvent } from '../../utils/logEvent';
import { ButtonText } from '../common/Text';

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  overflow: hidden;
  height: 100%;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
`;
const OuterContainer = styled(TappableCard)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-left: 20px;
  padding-bottom: 20px;
  // padding-top: 20px;
  padding-right: 20px;
  // margin-top: 20px;
  border-radius: 12px;
  border: 1px solid #cfc8ff66;

  box-shadow: none;

  margin-bottom: '0px';

  position: relative;
  z-index: 1;
`;

const OuterContainerGeneric = styled(TappableCard)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-left: 20px;
  padding-bottom: 20px;
  padding-top: 20px;
  padding-right: 20px;
  border: 1px solid #e3e3e3;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: none;
  position: relative;
  z-index: 1;
  margin-bottom: 20px;
`;

const DoctorInfoContainer = styled.div`
  display: flex;
  align-self: stretch;
  // align-items: center;
  justify-content: space-evenly;
  margin-bottom: 0.75rem;
  margin-top: 1.5rem;
  // border-bottom: 1px solid #f4f6f9;
  // padding-bottom: 10px;
`;

const DoctorPictureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 12px;
`;

const DoctorPicture = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 12px;
  object-fit: contain;
`;

const DoctorDetailsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
`;

const DoctorName = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.25px;
  color: #0f0b28;
  margin-bottom: 2px;
`;

const DoctorQualifications = styled.div`
  font-style: normal;
  font-size: 12px;
  line-height: 150%;
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  color: #767787;
  margin-bottom: 2px;
  margin-right: 16px;
`;

const DoctorExperience = styled.div`
  font-style: normal;
  font-size: 12px;
  line-height: 150%;
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  color: #767787;
  margin-bottom: 2px;
`;

const DoctorSecondaryInfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  background: #fffaeb;
  border-radius: 12px;
  padding: 4px;
`;

const HospitalText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  letter-spacing: 0.25px;
  color: #0f0b28;
  margin-left: 8px;
  line-height: 180%;
  margin-right: 8px;
`;

const ResponseContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 4px;
`;

const ResponseText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 150%;
  display: flex;
  align-items: center;
  letter-spacing: 0.25px;
  color: #0f0b28;
  margin-right: 10px;
`;

const FeesContainer = styled.div`
  display: flex;
  align-self: stretch;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f4f6f9;
  border-top: 1px solid #f4f6f9;
  padding: 12px 6px 12px 6px;
  margin-bottom: 10px;
`;

const FeesText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #0f0b28;
  display: flex;
  align-items: center;
  margin-right: 8px;
  white-space: nowrap;
`;

const PriceContainer = styled.div`
  display: flex;
  align-items: center;
`;

const OldPriceText = styled.div`
  text-decoration: line-through;
  margin-right: 0.5rem;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: #a5aab0;
`;

const PriceText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  text-align: right;
  letter-spacing: 0.25px;
  color: #0f0b28;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-self: stretch;
  align-items: stretch;
  justify-content: space-evenly;
`;

const StyledButton = styled(PrimaryButton)`
  display: flex;
  align-items: center;
  flex: 1;
  background: var(--primary-button);
  width: 90%;
  padding: 13px 36px 13px 36px;
  border-radius: 12px;
  // margin-right: 8px;
`;

const PaymentText = styled.p`
  border-radius: 11px 11px 0px 0px;
  display: flex;
  width: 100%;
  padding: 8px 8px 4px 4px;
  margin: 8px 0px 8px 20px;
`;

const Cashless = styled.p`
  background: #ffbb00;
  color: #0f0b28;
  padding: 4px;
  border-radius: 0px 0px 12px 12px;
  margin-top: -20px;
  width: 140px;
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.25px;
`;

const CashlessText = styled.span`
  padding: 2px 8px 2px 8px;
  gap: 4px;
  border-radius: 12px;
  opacity: 0px;

  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.25px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DoctorArrow = styled(FaChevronRight)`
  color: #0f0b28;
  float: right;
  height: 12px;
  margin-bottom: 12px;
`;
const NewIndicatorDiv = styled.div`
  // position: absolute;
  border-radius: 0px 0px 11px 11px;
  background: #f4f1ff;
  display: flex;
  bottom: 16px;
  left: 0px;
  width: 100%;
  z-index: 0;
  margin-top: -9px;
`;
const IndicatorContainer = styled.div`
  display: flex;
  padding-top: 1rem;
  padding-bottom: 0.7rem;
  padding-left: 0.7rem;
  align-items: center;
`;
const IndicatorText = styled.span`
  color: gray;
  text-align: center;
  font-feature-settings:
    'clig' off,
    'liga' off;

  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  letter-spacing: 0.25px;
  padding-left: 5px;
`;
const NewMainSelfBook = styled.div`
  position: relative;
  background: #ffffff;
  border: 1px solid #cfc8ff66;
  border-radius: 12px;
  margin-top: 20px;
`;

const NewMainGeneric = styled.div`
  position: relative;
`;

const DisclaimerImageDiv = styled.div`
  border-radius: 40px;
  background: #e7e1ff;
  height: 30px;
  width: 30px;
  position: relative;
  margin-left: 8px;
`;
const DisclaimerImage = styled.img`
  position: absolute;
  top: 7px;
  left: 5px;
  height: 15px;
  width: 20px;
  left: 5px;
`;

const ExperienceLocationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid #f4f6f9;
  flex-wrap: wrap;
`;

const ExperienceContainer = styled.div`
  display: flex;
  align-items: center;
  background: #ff865c1a;
  padding: 5px 8px 5px 8px;
  gap: 10px;
  border-radius: 40px;
  opacity: 0px;
  //styleName: Body/Paragraph_Medium;

  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #585969;
`;
const LocationContainer = styled.div`
  background: #1eb8651a;
  display: flex;
  align-items: center;
  padding: 5px 8px 5px 8px;
  gap: 10px;
  border-radius: 40px;
  opacity: 0px;
  //styleName: Body/Paragraph_Medium;

  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #585969;
`;

const CallClinicContainer = styled.a`
  border: 1px solid #1eb865;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 8px 5px 8px;
  //styleName: Body/Paragraph_Medium;

  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #585969;
`;

const GoToWebsiteContainer = styled.a`
  border: 2px solid #cfc8ff66;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 8px 5px 8px;
  //styleName: Body/Paragraph_Medium;

  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #585969;
`;

const SpecialistSelectCard = ({
  className,
  onTap,
  onBookingTap,
  onOpdTap,
  doctorPicture,
  doctorName,
  doctorQualifications,
  doctorExperience,
  doctorOrganizationText,
  doctorLocation,
  doctorOrganizationImage,
  basePrice,
  doctorPrice,
  feeLabel,
  opdLabel,
  bookingLabel,
  sponsor,
  sponsorLogo,
  offline,
  discountText,
  sameDaySlots,
  vaccinationCard,
  onDisclaimerClick,
  preBookAppt,
  key,
  lat,
  long,
  doctorId,
  illnessId,
  verticalId,
  user,
  centerContactNumber,
  centerWebsiteUrl,
  paymentText,
  card,
}) => {
  const history = useHistory();
  const prebookApptPage = () => {
    // history.push('/consultation/prebook-appointment-request', {
    //   doctorPicture: doctorPicture,
    //   doctorName: doctorName,
    //   doctorQualifications: doctorQualifications,
    //   doctorExperience: doctorExperience,
    //   doctorOrganizationText: doctorOrganizationText,
    //   doctorLocation: doctorLocation,
    //   doctorId: doctorId,
    //   lat: lat,
    //   long: long,
    //   illnessId: illnessId,
    //   verticalId: verticalId,
    //   user: user,
    // });
  };
  //
  return card === 'pre-book-appointment' ? (
    <NewMainSelfBook>
      {offline && (
        <PaymentText>
          <CashlessText
            style={{
              background:
                paymentText === 'Payment in 30 mins' ? '#159515' : '#72C20B',
            }}
          >
            <img
              src={
                paymentText === 'Payment in 60 mins'
                  ? PaymentIn60MinsIcon
                  : PaymentIn30MinsIcon
              }
              alt="payment"
            />
            {paymentText}
          </CashlessText>
        </PaymentText>
      )}
      <OuterContainer marginDown={sameDaySlots}>
        {vaccinationCard && <Cashless>Vaccine Available</Cashless>}
        {/* <div className="w-full">
        <DoctorArrow />
      </div> */}
        <DoctorInfoContainer onClick={onTap}>
          <DoctorPictureContainer>
            <DoctorPicture
              className="doctor-image"
              onError={() => DoctorPlaceHolder}
              src={
                vaccinationCard
                  ? doctorPicture === ''
                    ? HospitalIcon
                    : doctorPicture
                  : doctorPicture === null
                    ? DoctorPlaceHolder
                    : doctorPicture
              }
            />
          </DoctorPictureContainer>
          <DoctorDetailsContainer>
            <DoctorName>{doctorName}</DoctorName>
            <DoctorQualifications>{doctorQualifications}</DoctorQualifications>
            {/* <DoctorExperience>{doctorExperience}</DoctorExperience> */}
          </DoctorDetailsContainer>
          <div
            onClick={vaccinationCard && onTap}
            style={{ alignSelf: 'flex-start' }}
          >
            <DoctorArrow />
          </div>
        </DoctorInfoContainer>
        {!history.location.state?.isFromScanAndPay && (
          <div className="flex items-center gap-20px mb-20px">
            {centerContactNumber !== null && (
              <CallClinicContainer
                href={`tel: ${centerContactNumber}`}
                onClick={() => logEvent('Call centre tapped')}
              >
                <img src={GreenPhone} alt="Phone" />
                <div>Call Clinic</div>
              </CallClinicContainer>
            )}
            {centerWebsiteUrl !== null && (
              <GoToWebsiteContainer
                href={centerWebsiteUrl}
                target="_blank"
                onClick={() => logEvent('Go to website tapped')}
              >
                <img src={WebsiteImage} alt="Website" />
                <div>Go to Website</div>
              </GoToWebsiteContainer>
            )}
          </div>
        )}
        {vaccinationCard && (
          <DoctorSecondaryInfoContainer>
            <ResponseContainer>
              <img src={HSign} alt={'org'} width={24} height={24} />
              <HospitalText>{doctorOrganizationText}</HospitalText>
            </ResponseContainer>
            <ResponseText>{doctorLocation}</ResponseText>
          </DoctorSecondaryInfoContainer>
        )}
        {!vaccinationCard && (
          <ExperienceLocationContainer>
            <ExperienceContainer>
              <img src={Medal} alt="experience" width={16} height={16} />
              <div>{doctorExperience}</div>
            </ExperienceContainer>
            <LocationContainer>
              <img
                src={HospitalBuildingGreen}
                alt="address"
                width={16}
                height={16}
              />
              <div>{doctorOrganizationText}</div>
            </LocationContainer>
          </ExperienceLocationContainer>
        )}

        {doctorPrice && (
          <FeesContainer>
            <FeesText>
              {sponsorLogo
                ? discountText
                  ? discountText
                  : feeLabel?.replace(sponsor, '')
                : feeLabel}{' '}
              {sponsorLogo && (
                <img
                  src={sponsorLogo}
                  alt="logo"
                  height={16}
                  style={{ height: '16px', marginLeft: '8px' }}
                />
              )}
            </FeesText>

            <PriceContainer>
              {basePrice !== doctorPrice && (
                <>
                  {' '}
                  <FeesText>You pay</FeesText>
                  <OldPriceText>₹{basePrice}</OldPriceText>
                </>
              )}
              <PriceText>₹{doctorPrice}</PriceText>
              {vaccinationCard && (
                <DisclaimerImageDiv onClick={onDisclaimerClick}>
                  <DisclaimerImage src={vaccinationDisclaimerImage} />
                </DisclaimerImageDiv>
              )}
            </PriceContainer>
          </FeesContainer>
        )}
        {(bookingLabel !== '' || opdLabel !== '') && (
          <ButtonContainer>
            {bookingLabel !== '' && (
              <StyledButton onTap={() => onBookingTap()}>
                {/* <img
                  src={PrimaryButtonRect1}
                  alt="button"
                  className="absolute left-20px"
                />
                <img
                  src={PrimaryButtonRect2}
                  alt="button"
                  className="absolute left-40px"
                /> */}
                <ButtonText>{bookingLabel}</ButtonText>
              </StyledButton>
            )}
            {/* {doctorPrice !== 0 && opdLabel !== '' && (
              <StyledSubscriptionButton onTap={onOpdTap}>
                <SubscriptionButtonText>{opdLabel}</SubscriptionButtonText>
              </StyledSubscriptionButton>
            )} */}
          </ButtonContainer>
        )}
      </OuterContainer>
      {sameDaySlots === 1 && (
        <NewIndicatorDiv>
          <IndicatorContainer>
            <img src={SameDayTimeSlotLogo} alt="image2" />
            <IndicatorText>Same Day Slots</IndicatorText>
          </IndicatorContainer>
        </NewIndicatorDiv>
      )}
    </NewMainSelfBook>
  ) : (
    <NewMainGeneric>
      <OuterContainerGeneric onTap={onTap} marginDown={sameDaySlots}>
        {offline && <Cashless>Cashless Available</Cashless>}
        {vaccinationCard && <Cashless>Vaccine Available</Cashless>}

        <DoctorInfoContainer>
          <DoctorPictureContainer>
            <DoctorPicture
              className="doctor-image"
              onError={() => DoctorPlaceHolder}
              src={
                vaccinationCard
                  ? doctorPicture === ''
                    ? HospitalIcon
                    : doctorPicture
                  : doctorPicture === null
                    ? DoctorPlaceHolder
                    : doctorPicture
              }
            />
          </DoctorPictureContainer>
          <DoctorDetailsContainer>
            <DoctorName>{doctorName}</DoctorName>
            <DoctorQualifications>{doctorQualifications}</DoctorQualifications>
            <DoctorExperience>{doctorExperience}</DoctorExperience>
          </DoctorDetailsContainer>
          <div
            onClick={vaccinationCard && onTap}
            style={{ alignSelf: 'flex-start' }}
          >
            <DoctorArrow />
          </div>
        </DoctorInfoContainer>
        <DoctorSecondaryInfoContainer>
          <ResponseContainer>
            <img
              src={vaccinationCard ? HSign : DoctorOrgIcon}
              alt={'org'}
              width={24}
              height={24}
            />
            <HospitalText>{doctorOrganizationText}</HospitalText>
          </ResponseContainer>
          <ResponseText>{doctorLocation}</ResponseText>
        </DoctorSecondaryInfoContainer>
        {doctorPrice && (
          <FeesContainer>
            <FeesText>
              {sponsorLogo
                ? discountText
                  ? discountText
                  : feeLabel?.replace(sponsor, '')
                : feeLabel}{' '}
              {sponsorLogo && (
                <img
                  src={sponsorLogo}
                  alt="logo"
                  height={16}
                  style={{ height: '16px', marginLeft: '8px' }}
                />
              )}
            </FeesText>

            <PriceContainer>
              {basePrice !== doctorPrice && (
                <>
                  {' '}
                  <FeesText>You pay</FeesText>
                  <OldPriceText>₹{basePrice}</OldPriceText>
                </>
              )}
              <PriceText>₹{doctorPrice}</PriceText>
              {vaccinationCard && (
                <DisclaimerImageDiv onClick={onDisclaimerClick}>
                  <DisclaimerImage src={vaccinationDisclaimerImage} />
                </DisclaimerImageDiv>
              )}
            </PriceContainer>
          </FeesContainer>
        )}
        {(bookingLabel !== '' || opdLabel !== '') && (
          <ButtonContainer>
            {bookingLabel !== '' && (
              <StyledButton onTap={() => onBookingTap()}>
                <ButtonText>{bookingLabel}</ButtonText>
              </StyledButton>
            )}
            {/* {doctorPrice !== 0 && opdLabel !== '' && (
              <StyledSubscriptionButton onTap={onOpdTap}>
                <SubscriptionButtonText>{opdLabel}</SubscriptionButtonText>
              </StyledSubscriptionButton>
            )} */}
          </ButtonContainer>
        )}
        {sameDaySlots === 1 && (
          <img
            src={Top}
            style={{
              width: '8%',
              position: 'absolute',
              top: '0px',
              right: '14px',
            }}
            alt="first_image"
          />
        )}
        {sameDaySlots === 1 && (
          <img
            src={Bottom}
            style={{
              width: '8%',
              position: 'absolute',
              top: '4px',
              right: '14px',
            }}
            alt="new_image"
          />
        )}
      </OuterContainerGeneric>
      {sameDaySlots === 1 && (
        <NewIndicatorDiv>
          <IndicatorContainer>
            <img src={SameDayTimeSlotLogo} alt="image2" />
            <IndicatorText>Same Day Slots</IndicatorText>
          </IndicatorContainer>
        </NewIndicatorDiv>
      )}
    </NewMainGeneric>
  );
};

SpecialistSelectCard.propTypes = {
  onTap: PropTypes.func,
  onBookingTap: PropTypes.func,
  onOpdTap: PropTypes.func,
  doctorPicture: PropTypes.string.isRequired,
  doctorName: PropTypes.string.isRequired,
  doctorQualifications: PropTypes.string.isRequired,
  doctorExperience: PropTypes.string.isRequired,
  basePrice: PropTypes.string,
  doctorPrice: PropTypes.string,
  doctorOrganizationImage: PropTypes.string.isRequired,
  doctorOrganizationText: PropTypes.string.isRequired,
  doctorLocation: PropTypes.string.isRequired,
  feeLabel: PropTypes.string.isRequired,
  opdLabel: PropTypes.string,
  bookingLabel: PropTypes.string,
};

SpecialistSelectCard.defaultProps = {
  doctorPrice: '0',
  bookingLabel: '',
  opdLabel: '',
};

export default SpecialistSelectCard;
